import { useEffect } from 'react'

/**
 * Function created to enhance accessibility in desktop mode.
 * Sets the focus on the continue button when the modal opens,
 * or on the close button if the modal only has a close button.
 */

export const useAccessibility = (open, size, modalRef) => {
  useEffect(() => {
    if (open && size.isTiny) {
      modalRef.current.scrollTop = 0
    }
  }, [open, size.isTiny, modalRef])
}
/**
 * Allows the user to close the modal by pressing the "Space" or "Enter" key
 * while the focus is on the close button.
 */

export const handleKeyDown = (event, onClose) => {
  if (event.key === 'Enter' || event.key === ' ') {
    onClose()
  }
}
